import MainFrame from "../../../components/mainFrame";
import { Box, Button, IconButton } from "@mui/material";
import styled from "@emotion/styled";
import StickyTable from "../../../components/table";
import Navbar from "../../../components/navbar";
import { Cell } from "../../../components/table/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import { useModal } from "../../../components/modal";
import { DeleteModal } from "../../../components/appbar/modal";
import { smallButton } from "../../../components/Button";
import { useLocation } from "react-router-dom";
import AddModal from "./modal";
import CoursesMenuItems from "../menuItems";
import { Helmet } from "react-helmet";
import {
  useDeleteCourseFileMutation,
  useGetCourseFilesQuery,
} from "../../../app/services/files.api";
import { CourseFile } from "../../../types/files";
import TableRow from "@mui/material/TableRow";
// import CoursesMenuItems from "../menuItems";

const Container = styled(Box)({
  padding: "1rem",
  width: "100%",
  height: "100%",
  minHeight: "90vh",
  maxHeight: "90vh",
});

function Files() {
  const { setShow, setContent } = useModal();
  const {
    state: { title: courseName = "", courseId = "" },
  } = useLocation() as { state: { title: string; courseId: string } };

  const { data, isLoading, isFetching } = useGetCourseFilesQuery({ courseId });
  const [deleteFile] = useDeleteCourseFileMutation();
  function handleOpenModal(type: string, id?: string) {
    if (type === "edit" && id) {
      const file = data?.entities[id] as CourseFile;
      setContent({
        title: " ویرایش فایل",
        body: <AddModal courseId={courseId} file={file} />,
      });
    }
    if (type === "add") {
      setContent({
        title: " افزودن فایل",
        body: <AddModal courseId={courseId} />,
      });
    }
    if (type === "delete" && id) {
      setContent({
        title: "حذف فایل",
        body: (
          <DeleteModal
            handleDelete={() => {
              deleteFile({ courseId, fileId: id })
                .unwrap()
                .then(() => {
                  setShow(false);
                })
                .catch((err) => {});
            }}
          />
        ),
      });
    }
    setShow(true);
  }

  return (
    <Container bgcolor="primary.light">
      <Helmet>
        <title> فایل ها | پنل ادمین azno.school</title>
      </Helmet>
      <Navbar title={`فایل های ${courseName} `}>
        <Button
          onClick={() => handleOpenModal("add")}
          sx={[
            smallButton,
            {
              color: "divider",
              borderColor: "divider",
              borderStyle: "solid",
              borderWidth: "1px",
            },
          ]}
        >
          <AddIcon />
          افزودن فایل
        </Button>
      </Navbar>
      <StickyTable
        headers={[{ name: "عنوان" }, { name: "توضیحات" }]}
        operations={true}
        length={0}
        isLoading={isLoading || isFetching}
      >
        {(data?.ids || []).map((id, indx) => {
          const file = data?.entities[id] as CourseFile;
          return (
            <TableRow
              hover
              role="checkbox"
              tabIndex={-1}
              key={id}
              sx={{
                "&.MuiTableRow-root": {
                  cursor: "pointer",
                },
              }}
            >
              <Cell
                sx={{
                  "&.MuiTableCell-root": {
                    color: "divider",
                    fontSize: ".8rem",
                  },
                }}
              >
                {indx + 1}
              </Cell>
              <Cell>{file.title}</Cell>
              <Cell>{file?.desc}</Cell>
              <Cell
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IconButton onClick={() => handleOpenModal("edit", file._id)}>
                  <EditIcon sx={{ color: "divider" }} />
                </IconButton>
                <IconButton onClick={() => handleOpenModal("delete", file._id)}>
                  <DeleteIcon sx={{ color: "divider" }} />
                </IconButton>
              </Cell>
            </TableRow>
          );
        })}
      </StickyTable>
    </Container>
  );
}

export default MainFrame(Files, <CoursesMenuItems />);
